var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49,
    zoomAndPan: "magnify",
    viewBox: "0 0 36.75 31.5",
    height: 42,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "efa6192d9f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 0 L 35.601562 0 L 35.601562 26 L 5 26 Z M 5 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f9445b4905"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.164062 0 L 31 0 L 31 30.269531 L 0.164062 30.269531 Z M 0.164062 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0b9a7ca3f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 0 L 35.601562 0 L 35.601562 26 L 5 26 Z M 5 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c761593fd6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.164062 0 L 31 0 L 31 30.269531 L 0.164062 30.269531 Z M 0.164062 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2115e3430c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 0 L 35.601562 0 L 35.601562 26 L 5 26 Z M 5 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#efa6192d9f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5ea763",
    d: "M 5.582031 16.804688 L 9.726562 12.660156 L 14.652344 17.582031 L 31.917969 0.316406 L 35.902344 4.300781 L 14.554688 25.648438 L 5.582031 16.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f9445b4905)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5ea763",
    d: "M 28.449219 13.902344 C 28.5 14.363281 28.527344 14.832031 28.527344 15.308594 C 28.527344 22.492188 22.679688 28.339844 15.496094 28.339844 C 8.308594 28.339844 2.464844 22.492188 2.464844 15.308594 C 2.464844 8.121094 8.308594 2.277344 15.496094 2.277344 C 18.90625 2.277344 22.015625 3.59375 24.339844 5.75 L 25.949219 4.136719 C 23.210938 1.574219 19.535156 0 15.496094 0 C 7.054688 0 0.1875 6.867188 0.1875 15.308594 C 0.1875 23.75 7.054688 30.617188 15.496094 30.617188 C 23.933594 30.617188 30.800781 23.75 30.800781 15.308594 C 30.800781 14.144531 30.671875 13.011719 30.425781 11.925781 L 28.449219 13.902344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0b9a7ca3f0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5ea763",
    d: "M 5.582031 16.804688 L 9.726562 12.660156 L 14.652344 17.582031 L 31.917969 0.316406 L 35.902344 4.300781 L 14.554688 25.648438 L 5.582031 16.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ea763",
    d: "M 5.582031 16.804688 L 9.726562 12.660156 L 14.652344 17.582031 L 31.917969 0.316406 L 35.902344 4.300781 L 14.554688 25.648438 L 5.582031 16.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c761593fd6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5ea763",
    d: "M 28.449219 13.902344 C 28.5 14.363281 28.527344 14.832031 28.527344 15.308594 C 28.527344 22.492188 22.679688 28.339844 15.496094 28.339844 C 8.308594 28.339844 2.464844 22.492188 2.464844 15.308594 C 2.464844 8.121094 8.308594 2.277344 15.496094 2.277344 C 18.90625 2.277344 22.015625 3.59375 24.339844 5.75 L 25.949219 4.136719 C 23.210938 1.574219 19.535156 0 15.496094 0 C 7.054688 0 0.1875 6.867188 0.1875 15.308594 C 0.1875 23.75 7.054688 30.617188 15.496094 30.617188 C 23.933594 30.617188 30.800781 23.75 30.800781 15.308594 C 30.800781 14.144531 30.671875 13.011719 30.425781 11.925781 L 28.449219 13.902344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2115e3430c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5ea763",
    d: "M 5.582031 16.804688 L 9.726562 12.660156 L 14.652344 17.582031 L 31.917969 0.316406 L 35.902344 4.300781 L 14.554688 25.648438 L 5.582031 16.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_check.ed7c30d521d91b96a9e4714ee3e02753.svg";
export { ForwardRef as ReactComponent };